import blush from './blush.json'

export const EXPORT_WIDTH = 1080
export const EXPORT_HEIGHT = 1350

export const DEFAULT_PARAMS = {
  scale: 1.3,
  blur: 1.3,
  warp: 2.6,
  spread: 0.6,
  soft: 0.5,
  lateral: 0.55,
  grain: 0.16,
  grainSize: 1.2,
  seed: 3.7,
  haze: [0.862, 0.882, 0.859],
  wash: [0.62, 0.66, 0.6],
  mist: [0.2, 0.22, 0.19],
  ink: [0.055, 0.063, 0.055],
  olive: [0.22, 0.32, 0.06],
  acid: [0.839, 0.961, 0.145],
  band1: 0.78,
  band2: 0.64,
  band3: 0.5,
  band4: 0.36,
  band5: 0.22,
  drift: 0.15,
  loopDuration: 6,
  pixelScale: 1,
}

export const BLUSH_PARAMS = {
  ...DEFAULT_PARAMS,
  ...blush,
  pixelScale: 1,
}

export function fromSerializable(partial, pixelScale = 1) {
  return { ...DEFAULT_PARAMS, ...partial, pixelScale }
}

export function toSerializable(params) {
  const { pixelScale: _pixelScale, ...rest } = params
  return rest
}

export function rgbToHex([r, g, b]) {
  const h = (c) =>
    Math.round(Math.min(1, Math.max(0, c)) * 255)
      .toString(16)
      .padStart(2, '0')
  return `#${h(r)}${h(g)}${h(b)}`
}

export function hexToRgb(hex) {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim())
  if (!m) return [0, 0, 0]
  const n = parseInt(m[1], 16)
  return [((n >> 16) & 255) / 255, ((n >> 8) & 255) / 255, (n & 255) / 255]
}
